import { Container, Divider, Heading } from "@chakra-ui/react";
import CardForm from "components/ui/CardForm";
import HeaderBarInternal from "components/ui/HeaderBarInternal";
import { useParams } from "react-router-dom";
import TagForm from "../components/TagForm";

export default function PageCreateTag() {
  const { type } = useParams();
  return (
    <>
      <HeaderBarInternal title="Nova tag" backTo={`/tags/${type}`} />
      <Divider />

      <Container variant="internal" flexDirection="column">
        <Heading as="h1" size="h1">
          Dados da Tag
          <span>Identifique uma nova tag</span>
        </Heading>

        <CardForm>
          <TagForm type={type as string} />
        </CardForm>
      </Container>
    </>
  );
}
